<div class="modalDialog">
    <div>
      <div class="spinner">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>
      <p class="wait-text" style="text-align:center">
        Please wait while we verify your token
      </p>
    </div>
  </div>